import React from "react";
import Button from "../components/common/ui/Button";
import Activeicon from "../assets/svg/UnLocked.svg";
import Inactiveicon from "../assets/svg/Locked.svg";
import ExcelExport from "../components/common/ui/Export/ExcelExport.jsx";
import generateXlsx from "../components/common/export/generateXlsx.js";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckBoxInput from "../components/common/ui/Inputs/CheckBoxInput";
import { lockDownActions, masterActions, authActions } from "../_store";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";
import Table from "../components/common/table/Table";
import CustomLoader from "../components/common/ui/Loader";
import lockandunlock from "../assets/svg/lock-and-unlock.svg";
import { StoredProcedures } from "../_helpers/enumerator";

const LockDown = () => {
  const dispatch = useDispatch();
  const user = useSelector((x) => x.auth.user);
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );

  const reduxKioskLockDownList = useSelector(
    (state) => state.lockDown.lockdownList
  );
  const { lockdownStatus, lockdowndataList, lockdownList, loading } =
    useSelector((state) => state.lockDown);

  const reduxKioskSettingsList = useSelector(
    (state) => state.lockDown.unlockList
  );

  const isPageReloading = useSelector((state) => state.master?.isPageReload);

  const [selectAllKioskSettings, setselectAllKioskSettings] = useState(false);
  const [selectAllKioskLockDown, setselectAllKioskLockDown] = useState(false);

  //const [lockDownPagination?.pageNo, setlockDownPagination?.pageNo] = useState(1); // Current page
  //const [rowsPerPage, setRowsPerPage] = useState(10); // Default rows per page

  const [lockDownPagination, setLockDownPagination] = useState({
    pageNo: 1,
    rowCountPerPage: 10,
    sortBy: "LastAction DESC",
  });

  // Toastr Status
  useEffect(() => {
    switch (lockdownStatus?.IsSucceed) {
      case 1:
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode,
            ProcedureName: StoredProcedures?.LockDownSettingUpdate,
            UserAction: `Updated Kiosk Status(Lock/Unlock)`,
          })
        );
        showToastNotification("Kiosk Status updated successfully.", "success");

        dispatch(lockDownActions.clearUpdateLockdownStatus());
        break;

      case -1:
        showToastNotification(
          " Something went wrong. Please try again.",
          "error"
        );
        break;

      default:
        break;
    }
  }, [lockdownStatus]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, [commonFacilityCode]);

  useEffect(() => {
    if (commonFacilityCode === 0) return;
    dispatch(lockDownActions.LoadMenuAccessLockUnlockList(commonFacilityCode));
    dispatch(
      lockDownActions.LoadKioskLockdownList({
        facilityID: commonFacilityCode,
        sortBy: lockDownPagination?.sortBy,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );
    setLockDownPagination((prev) => ({
      ...prev,
      pageNo: 1,
      rowCountPerPage: 10,
    }));
  }, [commonFacilityCode, lockdownStatus, isPageReloading]);

  useEffect(() => {
    if (reduxKioskSettingsList && reduxKioskLockDownList) {
      const params = {
        ...lockdowndataList,
        type_MenuAccessLockdownModel: reduxKioskSettingsList,
        type_KioskLockdownModel: reduxKioskLockDownList,
      };

      // Dispatch to set management user data only after data dependencies are ready
      dispatch(lockDownActions.setLockDownData(params));
    }
  }, [dispatch, reduxKioskSettingsList, reduxKioskLockDownList]);

  // -----------------
  useEffect(() => {
    const isAllSelected = lockdowndataList?.type_KioskLockdownModel?.every((item) => item.LockDownActive === 1);
    setselectAllKioskLockDown(isAllSelected);
  }, [
    lockdowndataList,
    lockDownPagination?.pageNo,
    lockDownPagination?.rowCountPerPage,
  ]);

  //---------

  // Handler for the "Select All" checkbox
  const handleSelectAllClick = (isChecked) => {
    const kiosksSettingAllList =
      lockdowndataList?.type_MenuAccessLockdownModel?.map((item) => ({
        ...item,
        LockDownActive: isChecked ? 1 : 0, // Set all LockDownActive based on isChecked
      }));

    const updatedList = {
      ...lockdowndataList,
      type_MenuAccessLockdownModel: kiosksSettingAllList,
    };
    dispatch(lockDownActions?.setLockDownData(updatedList));

    setselectAllKioskSettings(isChecked); // Update the "select all" state
    //setKioskSettingsList(updatedList); // Update the list with the new state
  };

  const handleCheckboxClick = (LockDownSettingID, index, isChecked) => {
    const kiosksSettingList =
      lockdowndataList?.type_MenuAccessLockdownModel?.map((item, idx) => {
        // If index is 0, set all LockDownActive to 1; otherwise, set the specific item based on isChecked
        if (index === 0) {
          return { ...item, LockDownActive: isChecked ? 1 : 0 }; // Set all to 1 if checked, or all to 0 if unchecked
        } else {
          return item?.LockDownSettingID === LockDownSettingID
            ? { ...item, LockDownActive: isChecked ? 1 : 0 } // Set LockDownActive based on isChecked for the specific item
            : item; // Return the item unchanged if not the one being checked
        }
      });

    const updatedList = {
      ...lockdowndataList,
      type_MenuAccessLockdownModel: kiosksSettingList,
    };
    dispatch(lockDownActions?.setLockDownData(updatedList));

    // Check if all checkboxes are selected to update "select all" state
    const isAllSelected = kiosksSettingList.every(
      (item) => item.LockDownActive === 1
    );
    setselectAllKioskSettings(isAllSelected);
    // setKioskSettingsList(updatedList);
  };

  const kioskSettingsColumn = [
    {
      width: "50px",
      name: (
        <div className="checkbox-grid">
          <CheckBoxInput
            name="selectAllKioskSettings"
            id="selectAllKioskSettings"
            //checked={selectAllKioskSettings}
            checked={lockdowndataList?.type_MenuAccessLockdownModel?.every(
              (item) => item.LockDownActive === 1
            )}
            handleClick={(e) => handleSelectAllClick(e.target.checked)} // Pass the checked state
          />
        </div>
      ),
      selector: (row, index) => (
        <CheckBoxInput
          name={`IsMessageAcess_${row.LockDownSettingID}`}
          id={`IsMessageAcess_${row.LockDownSettingID}`}
          checked={row.LockDownActive === 1} // Set based on initial or updated LockDownActive value
          handleClick={(e) =>
            handleCheckboxClick(row?.LockDownSettingID, index, e.target.checked)
          }
        />
      ),
    },
    // {
    //   width: "300px",
    //   name: "Permissions",
    //   selector: (row) => row.LockDownName,
    //   sortable: true,
    //   cell: (row) => (
    //     <div id={`IsMessageAcess_${row.LockDownSettingID}`}>
    //       {row.LockDownName}
    //       <i
    //         className="fa fa-info-circle ms-1"
    //         title={`To lock the ${row.LockDownName}`}
    //       ></i>
    //     </div>
    //   ),
    // },
    {
      width: "300px",
      name: "Permissions",
      selector: (row) => row.LockDownName,
      sortable: true,
      cell: (row, index) => (
        <div
          id={`IsMessageAcess_${row.LockDownSettingID}`}
          onClick={() =>
            handleCheckboxClick(
              row?.LockDownSettingID,
              index,
              !(row.LockDownActive === 1)
            )
          }
          style={{ cursor: "pointer" }}
        >
          {row.LockDownName}
          <i
            className="fa fa-info-circle ms-1"
            title={`To lock the ${row.LockDownName}`}
          ></i>
        </div>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.LockDownStatus,
      sortable: true,
      cell: (row) => (
        <img
          title={row.LockDownStatus}
          src={row.LockDownStatus === "Unlocked" ? Activeicon : Inactiveicon}
          alt={row.LockDownStatus}
          className="in-icon-size"
        />
      ),
      //sortable: true,
    },
    {
      name: "Last Action By",
      sortable: true,
      selector: (row) => row.ModifiedBy,
      //sortable: true,
    },
    {
      name: "Last Action Date",
      sortable: true,
      selector: (row) => row.LastAction,
      //sortable: true,
    },
  ];

  //  ------
  const startIndex =
    (lockDownPagination?.pageNo - 1) * lockDownPagination?.rowCountPerPage;
  const endIndex = startIndex + lockDownPagination?.rowCountPerPage;
  // --
  const handleSelectAllLockdown = (isChecked) => {
    // Update only the items on the current page
    const kiosksLockdownselectAll =
      lockdowndataList?.type_KioskLockdownModel?.map((item, index) => {
        // Check if the current index is within the current page range
        // if (index >= startIndex && index < endIndex) {
        return {
          ...item,
          LockDownActive: isChecked ? 1 : 0, // Set LockDownActive based on isChecked
        };
        //}
        return item; // Return the item unchanged if it's not on the current page
      });

    const updatedList = {
      ...lockdowndataList,
      type_KioskLockdownModel: kiosksLockdownselectAll,
    };

    dispatch(lockDownActions?.setLockDownData(updatedList));

    setselectAllKioskLockDown(isChecked); // Update the "select all" state
    // setkioskLockDownList(updatedList); // Update the list with the new state
  };

  const handleCheckboxLockdownClick = (kioskID, isChecked) => {
    // Update the list based on the kioskID
    const kiosksLockdown = lockdowndataList?.type_KioskLockdownModel?.map(
      (item) =>
        item.KiosksID === kioskID
          ? { ...item, LockDownActive: isChecked ? 1 : 0 } // Set LockDownActive based on isChecked
          : item
    );

    const updatedList = {
      ...lockdowndataList,
      type_KioskLockdownModel: kiosksLockdown,
    };
    dispatch(lockDownActions?.setLockDownData(updatedList));

    const isAllSelected = kiosksLockdown.every((item) => item.LockDownActive === 1);

    setselectAllKioskLockDown(isAllSelected);
    // setkioskLockDownList(updatedList);
  };

  const kioskLockDownColumn = [
    {
      width: "50px",
      name: (
        <div className="checkbox-grid p-1 ">
          <CheckBoxInput
            name="selectAllKioskLockDown"
            id="selectAllKioskLockDown"
            checked={lockdowndataList?.type_KioskLockdownModel?.every((item) => item.LockDownActive === 1)} // Ensure all are selected
            handleClick={(e) => handleSelectAllLockdown(e.target.checked)} // Pass the checked state
          />
        </div>
      ),
      selector: (row, index) => (
        <div className="checkbox-grid">
          <CheckBoxInput
            name={`IsMessageAcess_${row.KiosksID}`}
            id={`IsMessageAcess_${row.KiosksID}`}
            checked={row.LockDownActive === 1 || selectAllKioskLockDown} // Set based on initial or updated LockDownActive value
            handleClick={(e) =>
              handleCheckboxLockdownClick(row.KiosksID, e.target.checked)
            }
          />
        </div>
      ),
    },
    // {
    //   width: "180px",
    //   name: "Kiosks Code",
    //   selector: (row) => row.KiosksCode,
    //   key: "KiosksCode",
    //   sortable: true,
    // },
    {
      width: "180px",
      name: "Kiosks Code",
      selector: (row) => row.KiosksCode,
      key: "KiosksCode",
      sortable: true,
      cell: (row) => (
        <div
          onClick={() =>
            handleCheckboxLockdownClick(
              row.KiosksID,
              !(row.LockDownActive === 1 || selectAllKioskLockDown)
            )
          }
          style={{ cursor: "pointer" }}
        >
          {row.KiosksCode}
        </div>
      ),
    },
    {
      width: "150px",
      name: "POD",
      cell: (row) => row.PodCode,
      key: "PodCode",
      sortable: true,
    },

    {
      name: "Computer Name",
      selector: (row) => row.ComputerName,
      key: "ComputerName",
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.LockDownStatus,
      key: "LockDownStatus",
      sortable: true,
      cell: (row) => (
        <div>
          <img
            title={row.LockDownStatus}
            src={row.LockDownStatus === "Unlocked" ? Activeicon : Inactiveicon}
            alt={row.LockDownStatus}
            className="in-icon-size"
          />
        </div>
      ),

      sortable: true,
    },
    {
      name: "Last Action By",
      selector: (row) => row.ModifiedBy,
      key: "LastAction",
      sortable: true,
    },
    {
      name: "Last Action Date",
      selector: (row) => row.LastAction,
      key: "LastAction",
      sortable: true,
    },
  ];

  // save func
  const handleLock = (e) => {
    e.preventDefault();
    // Construct the payload
    const payload = {
      facilityID: commonFacilityCode,
      createdBy: user?.ManagementUserID,
      type_KioskLockdownModel: lockdowndataList.type_KioskLockdownModel,
      type_MenuAccessLockdownModel:
        lockdowndataList.type_MenuAccessLockdownModel,
    };
    dispatch(lockDownActions.UpdateLockdownStatus(payload));
  };
  // reset the grid
  const handleReset = () => {
    setLockDownPagination((prev) => ({
      ...prev,
      pageNo: 1,
      rowCountPerPage: 10,
    }));
    dispatch(lockDownActions.LoadMenuAccessLockUnlockList(commonFacilityCode));
    dispatch(
      lockDownActions.LoadKioskLockdownList({
        facilityID: commonFacilityCode,
        sortBy: "LastAction DESC",
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );

    setselectAllKioskLockDown(false);
    setselectAllKioskSettings(false);
  };

  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...lockDownPagination };
    const newSortOrder = search.sortBy?.includes(column.key)
      ? search.sortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortBy = `${column.key} ${newSortOrder}`;
    setLockDownPagination(search);

    dispatch(
      lockDownActions.LoadKioskLockdownList({
        facilityID: commonFacilityCode,
        sortBy: `${column.key} ${newSortOrder}`,
        PageNo: lockDownPagination?.pageNo,
        RowCountPerPage: lockDownPagination?.rowCountPerPage,
      })
    );
  };

  const handlePageChange = (page) => {
    //setlockDownPagination?.pageNo(page);
    if (sorting) {
      sorting = false;
      return;
    }
    setLockDownPagination((prev) => ({
      ...prev,
      pageNo: page,
    }));
    setselectAllKioskLockDown(false); // Uncheck the select all checkbox
    dispatch(
      lockDownActions.LoadKioskLockdownList({
        facilityID: commonFacilityCode,
        sortBy: lockDownPagination?.sortBy,
        PageNo: page,
        RowCountPerPage: lockDownPagination?.rowCountPerPage,
      })
    );
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setLockDownPagination((prev) => ({
      ...prev,
      pageNo: 1,
      rowCountPerPage: newRowsPerPage,
    }));
    dispatch(
      lockDownActions.LoadKioskLockdownList({
        facilityID: commonFacilityCode,
        sortBy: lockDownPagination?.sortBy,
        PageNo: 1,
        RowCountPerPage: newRowsPerPage,
      })
    );
  };

  /// Excel download
  const handleClickExcel = () => {
    const title = "LockDown_List";
    const generateExcelColumns = [
      "Kiosks Code",
      "POD",
      "Computer Name",
      "Status",
      "Last Action By",
      "Last Action Date",
    ];

    const lockdownlist = lockdowndataList.type_KioskLockdownModel?.map(
      (obj) => ({
        Kiosks_Code: obj.KiosksCode,
        POD: obj.PodCode,
        Computer_Name: obj.ComputerName,
        Status: obj.LockDownStatus,
        Last_Action_By: obj.ModifiedBy,
        Last_Action_Date: obj.LastAction,
      })
    );

    generateXlsx(lockdownlist, generateExcelColumns, title);
  };

  if (loading) return <CustomLoader />;

  return (
    <div>
      {commonFacilityCode > 0 ? (
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card  shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100">
            <div className="mb-3">
              <h2 className="form_title_uppercase text-color">
                Kiosks/Inmate Settings Lockdown
              </h2>
            </div>

            <div className="d-flex flex-wrap  mb-2">
              <div className="d-flex flex-wrap  gap-4">
                <div className="mt-2">
                  <img
                    // title={Activeicon}
                    src={Activeicon}
                    alt={Activeicon}
                    className="in-icon-size"
                  />
                  <span className="ms-2 fw-600 font-size-15 v-mid">
                    UnLocked
                  </span>
                </div>
                <div className="mt-2">
                  <img
                    // title={Inactiveicon}
                    src={Inactiveicon}
                    alt={Inactiveicon}
                    className="in-icon-size"
                  />
                  <span className="ms-2 fw-600 font-size-15 v-mid">Locked</span>
                </div>
              </div>
            </div>

            <Table
              columns={kioskSettingsColumn}
              data={lockdowndataList.type_MenuAccessLockdownModel}
            />
          </div>
          <div className="card  shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
            <div className="mb-2">
              <h2 className="form_title_uppercase text-color">
                Kiosks Lockdown Information
              </h2>
            </div>

            <div className="d-flex flex-wrap  align-items-center mb-2 resp-space">
              <div className="d-flex flex-wrap justify-content-center align-items-center gap-4">
                <div className="mt-2">
                  <img
                    // title={Activeicon}
                    src={Activeicon}
                    alt={Activeicon}
                    className="in-icon-size"
                  />
                  <span className="ms-2 fw-600 font-size-15 v-mid">
                    UnLocked
                  </span>
                </div>
                <div className="mt-2">
                  <img
                    // title={Inactiveicon}
                    src={Inactiveicon}
                    alt={Inactiveicon}
                    className="in-icon-size"
                  />
                  <span className="ms-2 fw-600 font-size-15 v-mid">Locked</span>
                </div>
              </div>

              <div className="ms-auto">
                {reduxKioskLockDownList?.length > 0 ? (
                  <ExcelExport
                    variant="soft-gray"
                    handleExcelExport={handleClickExcel}
                  />
                ) : null}
              </div>
            </div>

            <Table
              columns={kioskLockDownColumn}
              data={lockdowndataList.type_KioskLockdownModel}
              pagination
              totalRowCount={lockdowndataList?.type_KioskLockdownModel?.length > 0 ? lockdowndataList?.type_KioskLockdownModel[0]?.TotalLockDownKioskCount : 0}
              onChangePage={handlePageChange} // Page change handler
              onChangeRowsPerPage={handleRowsPerPageChange} // Rows per page change handler
              currentPage={lockDownPagination?.pageNo}
              paginationPerPage={lockDownPagination?.rowCountPerPage}
              paginationServer={false}
              onSort={handleSort}
              serverSideSort
              sortColumn={lockDownPagination?.sortBy?.split(" ")[0]}
              sortDirection={lockDownPagination?.sortBy?.split(" ")[1]}

            //
            />
            <div className="mt-3 d-flex flex-wrap justify-content-center gap-3 flex-wrap">
              <Button
                className="me-2"
                label="LOCK/UNLOCK"
                type="submit"
                variant="danger"
                status={"success"}
                imgsrc={lockandunlock}
                onClick={handleLock}
              />
              <Button
                className="me-2"
                label="Reset"
                type="button"
                status="secondary"
                icon={"fa-solid fa-rotate-right"}
                onClick={handleReset}
              />
            </div>
          </div>
        </div>
      ) : (
        <h4 className="facility-card">Select a Facility Code from the list</h4>
      )}
    </div>
  );
};

export default React.memo(LockDown);
